import React from 'react';
import { Button, Link } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import useSiteData from '../../hooks/useSiteData';

function ContinueShopping() {
  const { externalAppNavigation } = useSiteData();
  const [emptyOrderHistory] = useTranslations(['emptyOrderHistory']);
  return (
    <Button
      render={p => (
        <Link href={externalAppNavigation.base} className={p.className}>
          {p.children}
        </Link>
      )}
      skin="primary"
      mb={7}
    >
      {emptyOrderHistory.continueShopping}
    </Button>
  );
}

export default ContinueShopping;
